import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Resolve, ActivatedRoute } from '@angular/router';
import { configUrl } from '@env/environment';
import { Observable } from 'rxjs';

@Injectable()
export class SponsorLevelsResolver implements Resolve<any> {
  constructor(private http: HttpClient) {}

  resolve(route: ActivatedRouteSnapshot, rstate: RouterStateSnapshot): Observable<any> {
    return this.getData();
  }

  getData(): Observable<any> {
    const url = `${configUrl.sponsorLevels}`;
    return this.http.get(url);
  }
}
